module.exports = __webpack_public_path__ + "img/KUCE-01.1a0ae815.png";